import CopilotPreviewExpandableCard from 'ai-addon-copilot-preview/components/CopilotPreview/CopilotPreviewExpandableCard';
import I18n from 'I18n';
import { useEffect, useMemo } from 'react';
import { useCsatSurvey } from '../../hooks/useCsatSurvey';
import { createTracker } from 'usage-tracker';
import events from '../../../../../events.yaml';
import { denormalizeTypeId } from 'customer-data-objects/constants/ObjectTypeIds';
import { View } from 'foundations-components/transitional/components/View';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const properties = {
  namespace: 'crm',
  screen: 'record'
};
const usageTracker = createTracker({
  events,
  properties
});
const USAGE_TRACKER_APP_LOCATION_KEY = 'CRM:Record:Timeline:ActivitySummary';
export const ActivitySummarySection = ({
  subjectId,
  objectTypeId
}) => {
  const defaultCopilotAction = useMemo(() => {
    return {
      objectId: subjectId,
      intent: 'object_engagements_summary',
      objectType: denormalizeTypeId(objectTypeId),
      objectTypeLabel: 'engagements',
      context: {
        summary_size: 'PREVIEW'
      }
    };
  }, [objectTypeId, subjectId]);
  const triggerSurvey = useCsatSurvey({
    qaId: 433,
    prodId: 1177
  });
  useEffect(() => {
    setTimeout(() => triggerSurvey(), 5000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_jsxs(View, {
    id: "activity-summary",
    "data-test-id": "activity-summary",
    paddingInline: "400",
    paddingBlockStart: "400",
    as: "div",
    children: [/*#__PURE__*/_jsx(Alert, {
      type: "warning",
      use: "inline",
      marginBlockEnd: "300",
      titleText: I18n.text('timeline.activitySummary.deprecationTitle'),
      children: I18n.text('timeline.activitySummary.deprecationBody')
    }), /*#__PURE__*/_jsx(CopilotPreviewExpandableCard, {
      appName: "CRM",
      copilotAction: defaultCopilotAction,
      numHoursTilSummaryStale: 0,
      previewKey: `object_summary_timeline:${objectTypeId}:${subjectId}`,
      previewSource: "CRM_CARD",
      previewTitle: I18n.text('timeline.activitySummary.activitySummary'),
      usageTracker: usageTracker,
      usageTrackerAppLocationKey: USAGE_TRACKER_APP_LOCATION_KEY,
      maxHeight: 80
    })]
  });
};